import { createElement } from "../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { AlignType } from "../../Controls/ControlEnums";
import { UIManager } from "../../UIManager";
import { AlignDockHelperContainer } from "./AlignDockHelperContainer";
import { BaseAlignElement } from "./BaseAlignElement";
/**
    * Pomocny dokovaci element pokud lezi v pozicni casti
    */
export class AlignDockHelperSelfContainer extends AlignDockHelperContainer {
    constructor(element: BaseAlignElement, parentElement: HTMLElement) {
        super(element, parentElement);

        this.element.classList.remove("AlignDockHelperContainer");
        this.element.classList.add("AlignDockHelperSelfContainer");

        if (element.alignType === AlignType.top || element.alignType === AlignType.bottom) {
            parentElement.classList.remove("Column");
            parentElement.classList.add("Row");
        } else if (element.alignType === AlignType.left || element.alignType === AlignType.right) {
            parentElement.classList.remove("Row");
            parentElement.classList.add("Column");

            //if (element.height) element.element.style.minHeight = element.height + "px";
        }
    }

    protected override _createElement(align: AlignType): void {
        this.element = createElement({ classes: ["AlignDockHelperSelfContainer", AlignType[align]], id: UIManager.instance.generateElementID() });
    }
}
